<template>
  <div>
    <v-layout>
      <v-flex>
        <products-table
          :headers="[...standardTableHeaders, ...tailHeaders]"
          :actions="actions"
          :standard-query="{ company: companyId }"
        />
      </v-flex>
    </v-layout>
    <add-item-modal
      v-if="addItemModal"
      :require-distributors="false"
      :addItemModal.sync="addItemModal"
      title="Add Item"
      :distributors="distributorLocations"
      :item="selectedItem"
      :categories="categories"
      @addItem="addItem"
    />
  </div>
</template>

<script>
import ProductsTable from "@/components/ProductsTable";
import AddItemModal from "@/components/shared/modals/AddItemModal";

export default {
  name: "Catalog",
  props: {
    distributorLocations: {
      type: Array,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    companyId: {
      type: String,
      required: false,
    },
  },
  async mounted() {
    await this.initialize();
  },
  data() {
    return {
      advancedSearchOptions: [],
      searchTerm: null,
      category: null,
      subcategory: null,
      products: [],
      productTableHeaders: [],
      filteredProducts: [],
      standardTableHeaders: [
        {
          text: "Product ID",
          value: "productCode",
          width: "5%",
        },
        {
          text: "Manufacturer",
          value: "manufacturer",
          width: "5%",
        },
        {
          text: "Category",
          value: "category.name",
          width: "5%",
        },
        {
          text: "Description",
          value: "description[0].value",
          width: "15%",
        },
      ],
      tailHeaders: [
        {
          text: "Customer Price",
          value: "price.formattedPrice",
          width: "10%",
        },
        {
          text: "",
          value: "action",
          width: "5%",
        },
      ],
      actions: [
        {
          color: "primary",
          click: this.setAddItem,
          text: "Add to Order",
        },
      ],
      addItemModal: false,
      selectedItem: null,
    };
  },
  components: {
    AddItemModal,
    ProductsTable,
  },
  watch: {
    products() {
      this.filteredProducts = this.products;
    },
  },
  methods: {
    generateAdvancedSearchOptions() {
      const { categories } = this;
      const options = [
        {
          component: "v-select",
          label: "Select Category",
          items: categories,
          value: "_id",
          key: "category",
          model: "catalog",
          text: "name",
        },
      ];
      this.advancedSearchOptions = options;
    },
    async initialize() {
      const { standardTableHeaders, tailHeaders } = this;
      this.productTableHeaders = [...standardTableHeaders, ...tailHeaders];
      this.generateAdvancedSearchOptions();
    },
    filter(key) {
      const { products, standardTableHeaders, tailHeaders } = this;
      if (key === "all") {
        Object.assign(this, {
          filteredProducts: products,
          productTableHeaders: [...standardTableHeaders, ...tailHeaders],
        });
      } else {
        const category = this.categories.find((cat) => {
          return cat._id === key;
        });

        // filter products
        this.filteredProducts = products.filter((prod) => {
          return prod.category._id === key;
        });
        // filter headers
        if (category.fieldSettings.length) {
          this.productTableHeaders = [
            ...this.standardTableHeaders,
            ...category.fieldSettings
              .filter((field) => {
                return field.showDefault;
              })
              .map((field) => {
                const { text, sortable, key } = field;
                const fieldIndex = category.fieldSettings.findIndex((cat) => {
                  return cat.key === key;
                });
                return {
                  text,
                  value: `${key}`,
                  sortable,
                };
              }),
            ...tailHeaders,
          ];
        }
      }
    },
    setAddItem(item) {
      this.addItemModal = true;
      this.selectedItem = item;
    },
    addItem(ctx) {
      this.$emit("addItem", ctx);
    },
  },
};
</script>
